<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="warning" @click="close">Close</b-button>
        </div>
      </div>
      <b-row>
        <b-col>
          <b-form-group label-cols="6" label-cols-lg="4" label="Customer ID">
            <b-input-group>
              <b-form-input v-model="model.customerID" disabled></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" @click="lkuBorrowerShow = true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group
            label-cols="6"
            label-cols-lg="4"
            label="Debtor Fullname"
          >
            <b-form-input
              v-model="model.debtorFullName"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group label-cols="4" label-cols-lg="2" label="Gender Code">
        <b-form-radio-group v-model="model.genderCode" disabled>
          <b-form-radio value="L">Laki-laki</b-form-radio>
          <b-form-radio value="P">Perempuan</b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-row>
        <b-col>
          <b-form-group label-cols="6" label-cols-lg="4" label="Id Type">
            <b-form-input disabled></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-cols="6" label-cols-lg="4" label="Id Number">
            <b-form-input disabled></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label-cols="4"
            label-cols-lg="4"
            label="Estimated Yearly Gross Income"
          >
            <b-form-input
              v-model="model.estimatedYearlyGrossIncome"
              disabled
            ></b-form-input> </b-form-group
        ></b-col>
        <b-col>
          <b-form-group
            label-cols="4"
            label-cols-lg="4"
            label="Source Of Income"
          >
            <b-form-input disabled></b-form-input> </b-form-group
        ></b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label-cols="4"
            label-cols-lg="4"
            label="Lease Phone Number"
          >
            <b-form-input disabled></b-form-input>
          </b-form-group>
        </b-col>
        <b-col
          ><b-form-group
            label-cols="4"
            label-cols-lg="4"
            label="Mobile Phone Number"
          >
            <b-form-input
              v-model="model.mobilePhoneNumber"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          ><b-form-group
            label-cols="4"
            label-cols-lg="4"
            label="Place Of Birth"
          >
            <b-form-input v-model="model.placeOfBirth" disabled></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label-cols="4" label-cols-lg="4" label="Date Of Birth">
            <b-form-input
              v-model="model.dateOfBirth"
              disabled
            ></b-form-input> </b-form-group
        ></b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label-cols="4"
            label-cols-lg="4"
            label="Profession Code"
          >
            <b-form-input
              v-model="model.professionCode"
              disabled
            ></b-form-input> </b-form-group
        ></b-col>
        <b-col
          ><b-form-group
            label-cols="4"
            label-cols-lg="4"
            label="Employer Industry Code"
          >
            <b-form-input
              v-model="model.employerIndustryCode"
              disabled
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group label-cols="4" label-cols-lg="2" label="Employer Name">
        <b-form-input v-model="model.employerName" disabled></b-form-input>
      </b-form-group>
      <b-form-group label-cols="4" label-cols-lg="2" label="Mother Maiden Name">
        <b-form-input v-model="model.motherMaidenName" disabled></b-form-input>
      </b-form-group>
      <b-form-group label-cols="4" label-cols-lg="2" label="Marital Status">
        <b-form-input
          v-model="model.marital_status_name"
          disabled
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols="4"
        label-cols-lg="2"
        label="Monthly Income Code"
      >
        <b-form-input disabled></b-form-input>
      </b-form-group>
      <b-form-group label-cols="4" label-cols-lg="2" label="Monthly Income">
        <b-form-input v-model="model.monthlyIncome" disabled></b-form-input>
      </b-form-group>
      <b-form-group label-cols="4" label-cols-lg="2" label="Citizen">
        <b-form-input v-model="model.citizen" disabled></b-form-input>
      </b-form-group>
      <b-form-group label-cols="4" label-cols-lg="2" label="Religion">
        <b-form-input v-model="model.religion_name" disabled></b-form-input>
      </b-form-group>
      <b-form-group label-cols="4" label-cols-lg="2" label="Email">
        <b-form-input disabled></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols="4"
        label-cols-lg="2"
        label="Last Education Code"
      >
        <b-form-input disabled></b-form-input>
      </b-form-group>
      <b-form-group label-cols="4" label-cols-lg="2" label="Address">
        <b-form-textarea v-model="model.address" disabled></b-form-textarea>
      </b-form-group>
      <b-row>
        <b-col>
          <b-form-group label-cols="4" label-cols-lg="4" label="Country">
            <b-form-input
              v-model="model.country"
              disabled
            ></b-form-input> </b-form-group
        ></b-col>
        <b-col
          ><b-form-group label-cols="4" label-cols-lg="4" label="Province">
            <b-form-input
              v-model="model.nama_province"
              disabled
            ></b-form-input> </b-form-group
        ></b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group label-cols="4" label-cols-lg="4" label="City">
            <b-form-input
              v-model="model.nama_city"
              disabled
            ></b-form-input> </b-form-group
        ></b-col>
        <b-col
          ><b-form-group label-cols="4" label-cols-lg="4" label="District">
            <b-form-input
              v-model="model.nama_district"
              disabled
            ></b-form-input> </b-form-group
        ></b-col>
      </b-row>

      <b-row>
        <b-col
          ><b-form-group label-cols="4" label-cols-lg="4" label="Sub District">
            <b-form-input
              v-model="model.nama_subDistrict"
              disabled
            ></b-form-input> </b-form-group
        ></b-col>
        <b-col
          ><b-form-group label-cols="4" label-cols-lg="4" label="Postal Code">
            <b-form-input disabled></b-form-input> </b-form-group
        ></b-col>
      </b-row>

      <hr />
      <div>
        <b-tabs justified>
          <b-tab title="Loan">
            <b-table
              responsive
              striped
              hover
              show-empty
              :busy="isBusy"
              :items="dataLoan"
              :fields="fields"
            >
              <template v-slot:cell(index)="data">{{
                data.index + 1
              }}</template>
              <template #cell(disbursement_date_first)="data">
                {{ data.item.disbursement_date_first | moment("DD MMM YYYY") }}
              </template>
              <template #cell(installmentStartDate)="data">
                {{ data.item.installmentStartDate | moment("DD MMM YYYY") }}
              </template>
              <template #cell(installmentEndDate)="data">
                {{ data.item.installmentEndDate | moment("DD MMM YYYY") }}
              </template>
              <template #cell(disbursement_amount)="data">
                {{ data.item.disbursement_amount | numFormat("0,0.00") }}
              </template>
              <template #cell(repayment_principal_date)="data">
                {{ data.item.repayment_principal_date | moment("DD MMM YYYY") }}
              </template>
              <template #cell(principal_repayment)="data">
                {{ data.item.principal_repayment | numFormat("0,0.00") }}
              </template>
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Disbursement">
            <b-table
              striped
              show-empty
              hover
              :busy="isBusy"
              :items="dataDisbursement"
              :fields="fieldsDisbursement"
            >
              <template v-slot:cell(index)="data">{{
                data.index + 1
              }}</template>
              <template #cell(disbursed_date)="data">
                {{ data.item.disbursed_date | moment("DD MMM YYYY") }}
              </template>
              <template #cell(loan_amount)="data">
                {{ data.item.loan_amount | numFormat("0,0.00") }}
              </template>
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Repayment">
            <b-table
              striped
              show-empty
              hover
              :busy="isBusy"
              :items="dataRepayment"
              :fields="fieldsRepayment"
            >
              <template #cell(repayment_date)="data">
                {{ data.item.repayment_date | moment("DD MMM YYYY") }}
              </template>
              <template #cell(total_repayment)="data">
                {{ data.item.total_repayment | numFormat("0,0.00") }}
              </template>
              <template #cell(principal)="data">
                {{ data.item.principal | numFormat("0,0.00") }}
              </template>
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </div>
    </b-card>
    <b-modal
      v-model="lkuBorrowerShow"
      size="lg"
      :hide-footer="true"
      title="List of Borrower"
      :centered="true"
    >
      <lku-borrower @click="onSelectBorrower"></lku-borrower>
    </b-modal>
  </div>
</template>
            
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import toastr from "mini-toastr";
toastr.init();

import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import crud from "../../apis/crud";
import lkuBorrower from "../../views/lookup/lkuBorrower.vue";

export default {
  components: { Loading, lkuBorrower },
  mixins: [validationMixin],
  validations: {
    model: {
      customerID: { required },
      debtorFullName: { required },
      genderCode: { required },
      mobilePhoneNumber: { required },
      maritalStatus: { required },
    },
  },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      dataLoan: [],
      fields: [
        {
          key: "index",
          label: "#",
          sortable: true,
        },
        {
          key: "partnerLoanApplicationNumber",
          label: "Loan Id",
          sortable: true,
        },
        {
          key: "installmentEndDate",
          label: "Due Date",
          sortable: true,
          thClass: "text-center",
          thStyle: "min-width:100px",
        },
        {
          key: "disbursement_date_first",
          label: "Disbursement First",
          sortable: true,
        },
        {
          key: "disbursement_amount",
          label: "Disbursement Amount",
          sortable: true,
        },

        {
          key: "repayment_principal_date",
          label: "Repayment Principal Date",
          sortable: true,
        },
        {
          key: "principal_repayment",
          label: "Principal Repayment",
          sortable: true,
        },
        // {
        //   key: "late_fee",
        //   label: "Late Fee",
        //   sortable: true,
        // },
        // {
        //   key: "service_Charge",
        //   label: "Service Charge",
        //   sortable: true,
        // },
        {
          key: "interest_repaid",
          label: "Interest Repaid",
          sortable: true,
        },
        {
          key: "principal_outstanding",
          label: "Principal OS.",
          sortable: true,
        },
        {
          key: "interest_estimate",
          label: "Interest Estimate",
          sortable: true,
        },
        {
          key: "dpd",
          label: "DPD",
          sortable: true,
        },
      ],
      dataDisbursement: [],
      fieldsDisbursement: [
      {
          key: "index",
          label: "#",
          sortable: true,
        },
        {
          key: "loan_id",
          label: "Loan ID",
          sortable: true,
        },
        {
          key: "disbursed_date",
          label: "Disbursed Date",
          sortable: true,
        },
        {
          key: "loan_amount",
          label: "Loan Amount",
          sortable: true,
        },
      ],
      dataRepayment: [],
      fieldsRepayment: [
        {
          key: "index",
          label: "#",
          sortable: true,
        },
        {
          key: "repayment_date",
          label: "Repayment Date",
          sortable: true,
        },
        {
          key: "total_repayment",
          label: "Total Repayment",
          sortable: true,
        },
        {
          key: "principal",
          label: "Principal",
          sortable: true,
        },
        {
          key: "interest_repaid",
          label: "Interest Repaid",
          sortable: true,
        },
      ],
      model: {
        borrowerKey: "",
        customerID: "",
        debtorFullName: "",
        genderCode: "",
        estimatedYearlyGrossIncome: "",
        mobilePhoneNumber: "",
        placeOfBirth: "",
        dateOfBirth: "",
        professionCode: "",
        employerName: "",
        employerIndustryCode: "",
        motherMaidenName: "",
        maritalStatus: "",
        monthlyIncome: "",
        citizen: "",
        religion: "",
        address: "",
        country: "",
        province: "",
        city: "",
        district: "",
        subDistrict: "",
      },
      lkuBorrowerShow: false,
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      console.log(this.$v.model);
      return this.$v.model.$invalid;
    },
  },
  async created() {
    if (this.$route.params.borrowerKey) {
      this.getData(this.$route.params.borrowerKey);
    }
  },
  methods: {
    onSelectBorrower(selected) {
      this.lkuBorrowerShow = !this.lkuBorrowerShow;
      this.getData(selected.borrowerKey);
    },
    async getData(borrowerKey) {
      if (borrowerKey) {
        toastr.info("Loading Agreement View, Please Wait...");
        this.isBusy = true;
        try {
          this.dataLoan = [];
          this.dataDisbursement = [];
          this.dataRepayment = [];
          const data = await crud.detail({
            tablename: "vwborrower",
            key: borrowerKey,
          });
          const row = data;
          for (var key in row) {
            this.model[key] = row[key];
          }
          this.model.dateOfBirth = moment(this.model.dateOfBirth).format(
            "DD MMM YYYY"
          );
          
          console.log('data.customerID',data.customerID)
          // const [dataLoan,dataDisbursement,dataRepayment] = await Promise.all([ 
          // crud.list({
          //   tablename: "loanapplication",
          //   customQuery: `customerID=${encodeURIComponent(data.customerID)}`,
          // }),
          // crud.list({
          //   tablename: "disbursementcrud",
          //   customQuery: `customerID=${encodeURIComponent(data.customerID)}`,
          // }),crud.list({
          //   tablename: "repaymentcrud",
          //   customQuery: `customerID=${encodeURIComponent(data.customerID)}`,
          // })])
          if(data && data.customerID){
            this.dataLoan = await crud.list({
              tablename: "loanapplication",
              customQuery: `customerID=${encodeURIComponent(data.customerID)}`,
            });

            this.dataDisbursement = await crud.list({
              tablename: "disbursementcrud",
              customQuery: `customerID=${data.customerID}`,
            });
            console.log(`customerID=${encodeURIComponent(data.customerID)}`)

            this.dataRepayment = await crud.list({
              tablename: "repaymentcrud",
              customQuery: `customerID=${encodeURIComponent(data.customerID)}`,
            });
          }

          this.isBusy = false;
          this.$forceUpdate();
          toastr.clear;
        } catch (error) {
          this.isBusy = false;
          console.log("error : ", error);
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push({ name: "master.borrower" });
    },
  },
};
</script>